module.exports = __webpack_public_path__ + "static/media/filter.70b5ce28.png";


//////////////////
// WEBPACK FOOTER
// ./src/landing/images/filter.png
// module id = 344
// module chunks = 0